import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import { connect } from 'react-redux';
import { Input, Grid } from 'semantic-ui-react';
import { find } from 'lodash';
import { updateLayer } from '../../../data/analysis/layersDispatchers';

const ToolTipSlider = Slider.createSliderWithTooltip(Slider);

function getLayer(state) {
  const { activeLayerId } = state.analysis.single;
  if (activeLayerId) {
    const layer = find(state.analysis.single.layers, { id: activeLayerId });
    if (layer) {
      return layer;
    }
  }
  return null;
}

class HeatmapWorkerParameters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      textualVisualSpan: null
    };

    this.onSliderChange = this.onSliderChange.bind(this);
  }

  onSliderChange(visualSpan) {
    const { dispatch, layer } = this.props;
    if (layer) {
      if (!layer.layer_heatmap_parameters_association) {
        layer.layer_heatmap_parameters_association = {};
      }
      layer.layer_heatmap_parameters_association.visual_span = visualSpan;

      dispatch(updateLayer(layer));
    }
    this.setState({
      textualVisualSpan: visualSpan
    });
  }

  render() {
    const { defaultVisualSpan } = this.props;
    const { textualVisualSpan } = this.state;

    return (
      <Grid className="heatmapWorkerParameters">
        <Grid.Row className="title">
          <span>Visual Span</span>
        </Grid.Row>
        <Grid.Row className="input">
          <Grid.Column width={11}>
            <ToolTipSlider
              min={1}
              max={10}
              step={1}
              defaultValue={textualVisualSpan || defaultVisualSpan}
              tipFormatter={v => v}
              onChange={this.onSliderChange}
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              type="text"
              readOnly
              value={textualVisualSpan || defaultVisualSpan}
              style={{
                width: '4em'
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

HeatmapWorkerParameters.propTypes = {
  defaultVisualSpan: PropTypes.number,
  layer: PropTypes.shape({
    layer_heatmap_parameters_association: PropTypes.shape({
      visual_span: PropTypes.number
    })
  })
};

HeatmapWorkerParameters.defaultProps = {
  defaultVisualSpan: 4,
  layer: null
};

export default connect(state => ({
  layer: (() => {
    return getLayer(state);
  })(),
  defaultVisualSpan: (() => {
    const layer = getLayer(state);
    if (layer && layer.layer_heatmap_parameters_association) {
      return layer.layer_heatmap_parameters_association.visual_span;
    }
    return 4; // default value if no parameters are present
  })()
}))(HeatmapWorkerParameters);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/HeatmapWorkerParameters.js